import { render, staticRenderFns } from "./ContactReportForm.vue?vue&type=template&id=22ee59dc"
import script from "./ContactReportForm.vue?vue&type=script&lang=js"
export * from "./ContactReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports